// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"About_aboutContainer__2SJlQ","element1":"About_element1__7T_NT","element2":"About_element2__Cy5G3","element3":"About_element3__3vFSf","badge":"About_badge__lYYfL"};